import base64 from './base64.js';
import api from '../api.js';
import store from '../../src/store/index.js'
var gNextCode = ''
var gLastTime = ''
var gCode = ''
// 判断是否拥有权限
const fGetSmMenuQx = async (authType, menu) => {
  // 是  1001  不做权限
  if ((store.state.smElabelAdmin.orgId == '372211050001' && authType == 'orgAuth')  ||
      (store.state.smElabelAdmin.supperAuth == '是' && authType == 'userAuth') || !menu) {
    // console.log('1001 员工 - ', menu, ' - 权限通过')
    return {
      auth_name: menu,
      resolve: true
    }
  }
  console.log(store.state[authType])
  let idx = store.state[authType].findIndex(item => {
    return item.auth_name == menu
  })
  console.log(idx)
  if (idx != -1) {
    // console.log(menu, ' - 权限通过')
    return {
      auth_name: menu,
      resolve: true
    }
  } else {
    return {
      auth_name: menu,
      resolve: false
    }
  }
}

const fGetSassMallInfo = async ({
  mchId,
  pageSize,
  nowPage,
  search
}) => {
  let js = {};
  js['OPER'] = 'MALL_LIST'
  js['MCH_ID'] = mchId
  js['SEARCH_STR'] = search

  js['PAGE_SIZE'] = pageSize
  js['NOW_PAGE'] = nowPage
  console.log(js)
  let res = await api.smUnionPlatformApi.fPostToSmUnionPlatformQueryApi('GET_SMBOX_SHOP_SAAS_MALL_INFO', js)
  console.log(res)
  return res;
};

//定位
const fGetAdrLongLat = async ({
  locationAddress,
  location
}) => {
  let js = {};
  js['OPER'] = 'BAIDU'
  let adr = location
  if (locationAddress.length == 3) {
    adr = locationAddress[0] + locationAddress[1] + locationAddress[2] + location
  }
  js['ADR'] = adr
  console.log(js)
  let res = await api.smUnionPlatformApi.fPostToSmSellMainSrvApi('GET_ADR_LONG_LAT ', js)
  console.log(res)
  return res;
};


// 扫码枪操作
const fTableScan = async (e, row, column, rowIndex, fChoosePro, fQuerySearchPro) => {
  let nextCode, nextTime = '';
  let lastTime = gLastTime;
  let code = gCode;
  if (window.event) { // IE
    nextCode = e.keyCode
  } else if (e.which) { // Netscape/Firefox/Opera
    nextCode = e.which
  }
  nextTime = new Date().getTime();
  //字母上方 数字键0-9 对应键码值 48-57; 数字键盘 数字键0-9 对应键码值 96-105
  if ((nextCode >= 48 && nextCode <= 57) || (nextCode >= 96 && nextCode <= 105)) {
    let codes = {
      '48': 48,
      '49': 49,
      '50': 50,
      '51': 51,
      '52': 52,
      '53': 53,
      '54': 54,
      '55': 55,
      '56': 56,
      '57': 57,
      '96': 48,
      '97': 49,
      '98': 50,
      '99': 51,
      '100': 52,
      '101': 53,
      '102': 54,
      '103': 55,
      '104': 56,
      '105': 57
    };
    nextCode = codes[nextCode];
    nextTime = new Date().getTime();
  }
  // 第二次输入延迟两秒，删除之前的数据重新计算
  if (nextTime && lastTime && nextTime - lastTime > 2000) {
    code = String.fromCharCode(nextCode);
  } else {
    code += String.fromCharCode(nextCode)
  }
  // 保存数据
  gNextCode = nextCode;
  gLastTime = nextTime;
  gCode = code;
  // 键入Enter
  if (e.which == 13) {
    // this.$message('条码' + code);
    console.log('条码' + code)
    await fQuerySearchPro(code.trim())
    fChoosePro(code.trim(), row, rowIndex)
    //键入回车务必清空code值
    gCode = ''
    return false;
  }
}


//获取页面实例
const fSmGetPrePage = (pageNo = 2) => {
  let pages = getCurrentPages();
  // console.log(pages)
  let prePage = pages[pages.length - pageNo];
  // #ifdef H5
  return prePage;
  // #endif
  return prePage.vm;
}





//获取url参数
const fSmGetUrlParam = (name, deBase64 = false) => {
  name = name.replace(/[]/, "\[").replace(/[]/, "\[").replace(/[]/, "\\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.parent.location.href);
  if (results == null) return "";
  else {
    if (deBase64) {
      return Base64.encode(results[1]);
    }
    return results[1];
  }
};


//获取固定长度随机码
const fSmGetFixLenRomStr = (strLen, strType = 'num') => {
  var resStr = "";
  var romLen = 10;
  if (strType == 'num') {
    var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
  } else {
    var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E", "F", "G", "H",
      "I",
      "G", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z");
    romLen = 32;
  }

  for (let i = 0; i < strLen; i++) {
    let charIndex = Math.floor(Math.random() * romLen);
    resStr += selectChar[charIndex];
  }
  if (resStr.length != strLen) {
    fGetFixLenRomStr(strLen);
  }
  return resStr;
}

// 压缩图片
const fSmCompressImg = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onloadend = function(e) {
      let img = new Image();
      img.onload = function() {
        let canvasWidth = img.width; // 图片原始长宽
        let canvasHeight = img.height;
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        // 创建固定750宽度的图片，可自定义大小
        canvas.width = 800;
        canvas.height = (800 * canvasHeight) / canvasWidth;
        ctx.drawImage(img, 0, 0, 800, (800 * canvasHeight) / canvasWidth);
        canvas.toBlob(
          function(blob) {
            // 创建file文件
            let pressFile = new File([blob], file.name, {
              type: file.type
            });
            Object.defineProperty(pressFile, 'path', {
              get: () => URL.createObjectURL(blob)
            });
            return resolve(pressFile);
          },
          file.type,
          1 // 图片质量，值0-1之间，可不填默
        );
      };
      img.src = e.target.result;
    };
    // 读取 File 对象，然后触发 loadend 事件
    reader.readAsDataURL(file);
  });
}

//判断是否在微信中
const fSmIsWechat = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/micromessenger/i) == 'micromessenger') {
    // console.log('是微信客户端')
    return true;
  } else {
    // console.log('不是微信客户端')
    return false;
  }
}

const fSmIsAli = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/Alipay/i) == "alipay") {
    // console.log('是支付宝客户端')
    return true;
  } else {
    // console.log('不是支付宝客户端')
    return false;
  }
}

//base64加密
const fSmUtf8ToBase64 = (str) => {
  return window.btoa(unescape(encodeURIComponent(str)));
}
//base64解密
const fSmBase64ToUtf8 = (str) => {
  return decodeURIComponent(escape(window.atob(str)));
}
const fSmPayParams = (userPhone, mallId, djType, djDhId, payDesc, payMoney) => {
  userPhone = fSmUtf8ToBase64(userPhone);
  mallId = fSmUtf8ToBase64(mallId);
  djType = fSmUtf8ToBase64(djType);
  djDhId = fSmUtf8ToBase64(djDhId);
  payDesc = fSmUtf8ToBase64(payDesc);
  payMoney = fSmUtf8ToBase64(payMoney);


  let param = 'userPhone=' + userPhone + '&mallId=' + mallId + '&djType=' + djType +
    '&djDhId=' + djDhId + '&payDesc=' + payDesc + '&payMoney=' + payMoney;
  param.replace(/%/g, '%25');
  return param;
}

//判断字符是否为空
const fSmIsEmpty = (value) => {

  return (
    value === null || value === undefined ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )


}
//验证手机号码
const fSmIsPhone = (Phone) => {
  let phone = Phone.replace(/\s/g, ""); //去除空格
  let regs = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  let result = regs.test(phone)
  if (!result) {
    return false
  } else {
    return true
  }
}

//判断h5页面是微信还是支付宝调起
const fSmIsGetBrowserType = () => {
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    return "微信";
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    return "支付宝";
  } else {
    return "其他";
  }
}

//组装树结构
const fTranListToTreeData = (list) => {
  // 1. 定义两个中间变量
  const treeList = [], // 最终要产出的树状数据的数组
    map = {} // 存储映射关系
  // 2. 建立一个映射关系，并给每个元素补充children属性.
  // 映射关系: 目的是让我们能通过id快速找到对应的元素
  // 补充children：让后边的计算更方便
  list.forEach(item => {
    item.children = []
    map[item.cls_id] = item
  })
  // 3. 循环
  list.forEach(item => {
    // 对于每一个元素来说，先找它的上级
    //    如果能找到，说明它有上级，则要把它添加到上级的children中去
    //    如果找不到，说明它没有上级，直接添加到 treeList
    let parent = map[item.p_cls_id]
    if (parent && item.cls_id.length > 2) {
      if (item.cls_id != item.p_cls_id) {
        parent.children.push(item)
      }
    } else {
      treeList.push(item)
    }
  })
  // 4. 返回出去
  return treeList
}
//[整单折扣,会员价,会员折扣] 这种类型字符串转数值
const parsestring = (str) => {
  //一个 flag 标识当前的对应结束点let right = null;
  let right = null;
  let parent = null;
  let key = '';
  let value = "";
  for (let i = 0; i < str.length; i++) {
    const letter = str[i];
    if (letter === "[") {
      //这里是一个“高街元素”，做好笔记!
      //小老虎这里巧妙地将相对应右括号记录下来，/这样在下面判断结束的时候就会变得相当便捷。right - ']";
      right = ']';
      parent = new Array();
    } else if (letter === ']') {
      if (right === letter && value) {
        parent.push(value);
        value = '';
        right = null;
      }
    } else if (letter === ',') {
      if (right === ']') {
        parent.push(value);
        value = '';
      }
    } else {
      // non empty
      if (letter && letter !== ' ') {
        value += letter;
      }
    }
  }
  return parent;
}
// 去重
const uniqueArray = (array, key) => {
  let result = [array[0]];
  for (let i = 1; i < array.length; i++) {
    let item = array[i];
    let repeat = false;
    for (let j = 0; j < result.length; j++) {
      if (item[key] == result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}
// 去重
const uniqueArray1 = (array, key, key1) => {
  let result = [array[0]];
  for (let i = 1; i < array.length; i++) {
    let item = array[i];
    let repeat = false;
    for (let j = 0; j < result.length; j++) {
      if (item[key] == result[j][key] && item[key1] == result[j][key1]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}
//验证
const fIsCode = (str) => {
  let re = /^[0-9a-zA-Z]*$/g; //判断字符串是否为数字和字母组合     //判断正整数 /^[1-9]+[0-9]*]*$/
  if (re.test(str)) {
    return false
  } else {
    return true;
  }
}
const fDownLoadExeclMb = (mbName) => {
  location.href = 'http://soft.sanmipos.com/smSellEx/excelDrMb/' + mbName + '.xls'
}
export default {
  fSmGetPrePage, //获取页面实例
  fSmGetUrlParam, //获取url参数
  fSmCompressImg, // 图片上传
  fSmGetFixLenRomStr, //获取固定长度随机码
  fSmIsWechat, //微信浏览器
  fSmIsAli, //支付宝浏览器
  fSmPayParams, // 支付参数组装
  fSmUtf8ToBase64, // url base64 加密
  fSmBase64ToUtf8, // url base64 解密
  fSmIsEmpty, //判断字符是否为空
  fSmIsPhone, //验证手机号码
  fSmIsGetBrowserType, //判断h5页面是微信还是支付宝调起
  fTranListToTreeData, //组装树结构
  parsestring, //字符串转数值
  uniqueArray, //数组去重
  uniqueArray1,
  fIsCode, //验证条形码
  fDownLoadExeclMb,
  fTableScan,
  fGetAdrLongLat, //获取门店经纬度
  fGetSmMenuQx, //权限判断
  fGetSassMallInfo, //获取sass门店
}



//////////////////
// WEBPACK FOOTER
// ./common/global/smCom.js
// module id = null
// module chunks = 